
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10.781 12.584A.9.9 0 019.5 13.848l-5.2-5.27a.9.9 0 01.007-1.27l5.2-5.163a.9.9 0 011.268 1.277l-4.563 4.53 4.57 4.632z","fill":"currentColor","fill-rule":"evenodd"}})])
          )
        }
      }
    